import React, { PropsWithChildren } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { cn, easeOutCubic } from '../../utils';

type DialogOverlayProps = {
  isOpen: boolean;
  handleClose: () => void;
  zIndexClassName?: string; // Optional zIndex class
};

export const DialogOverlay = ({
  isOpen,
  children,
  handleClose,
  zIndexClassName = 'z-50',
}: PropsWithChildren<DialogOverlayProps>) => {
  const animationVariants = {
    initial: {
      opacity: 0,
    },
    animate: {
      opacity: isOpen ? 1 : 0,
      transition: {
        duration: 0.2,
        ease: easeOutCubic,
      },
    },
    exit: {
      opacity: 0,
      transition: {
        duration: 0.1,
        ease: easeOutCubic,
      },
    },
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          variants={animationVariants}
          initial="initial"
          animate="animate"
          exit="exit"
          className={cn(
            'p-0 items-end sm:p-6 top-0 w-full left-0 h-full fixed sm:items-center justify-center',
            zIndexClassName,
            {
              flex: isOpen,
              hidden: !isOpen,
            },
          )}
          style={style}
          onClick={handleClose}
        >
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  );
};

const style = {
  backgroundColor: 'rgba(0,0,0, .5)',
};
